// Funções para máscara de moeda brasileira
// Formato: R$ 1.234,56 (ponto como separador de milhar, vírgula como separador decimal)

export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
};

export const parseCurrency = (value: string): number => {
  // Remove o prefixo "R$ " e espaços
  const cleanValue = value.replace(/R\$\s*/g, '');
  
  // Remove todos os pontos (separadores de milhar)
  const valueWithoutDots = cleanValue.replace(/\./g, '');
  
  // Substitui vírgula por ponto para conversão
  const numericValue = valueWithoutDots.replace(',', '.');
  
  return parseFloat(numericValue) || 0;
};

export const applyCurrencyMask = (value: string): string => {
  // Remove tudo que não é número
  const numbers = value.replace(/\D/g, '');
  
  // Se não há números, retorna R$ 0,00
  if (numbers.length === 0) {
    return 'R$ 0,00';
  }
  
  // Converte para centavos
  const cents = numbers.padStart(3, '0');
  const reais = cents.slice(0, -2);
  const centavos = cents.slice(-2);
  
  // Formata com pontos e vírgulas
  let formatted = '';
  if (reais.length > 0) {
    // Adiciona pontos a cada 3 dígitos da direita para a esquerda
    for (let i = reais.length - 1, j = 0; i >= 0; i--, j++) {
      if (j > 0 && j % 3 === 0) {
        formatted = '.' + formatted;
      }
      formatted = reais[i] + formatted;
    }
  } else {
    formatted = '0';
  }
  
  return `R$ ${formatted},${centavos}`;
};

// Função de teste para verificar se a máscara está funcionando
export const testCurrencyMask = () => {
  console.log('Testando máscara de moeda:');
  console.log('applyCurrencyMask("123456") ->', applyCurrencyMask("123456"));
  console.log('applyCurrencyMask("1000000") ->', applyCurrencyMask("1000000"));
  console.log('applyCurrencyMask("50") ->', applyCurrencyMask("50"));
  console.log('parseCurrency("R$ 1.234,56") ->', parseCurrency("R$ 1.234,56"));
  console.log('parseCurrency("R$ 10.000,00") ->', parseCurrency("R$ 10.000,00"));
};

// Exemplos de uso:
// applyCurrencyMask("123456") -> "R$ 1.234,56"
// applyCurrencyMask("1000000") -> "R$ 10.000,00"
// applyCurrencyMask("50") -> "R$ 0,50"
// parseCurrency("R$ 1.234,56") -> 1234.56
// parseCurrency("R$ 10.000,00") -> 10000.00

export const handleCurrencyInput = (
  event: React.ChangeEvent<HTMLInputElement>,
  setValue: (value: string) => void
) => {
  const input = event.target;
  const value = input.value;
  
  // Aplica a máscara
  const maskedValue = applyCurrencyMask(value);
  setValue(maskedValue);
}; 